import React from 'react';
import OverviewDashboard from '../overview/OverviewDashboard';

/**
 * Unit Manager Overview Dashboard.
 * Uses shared OverviewDashboard layout with scope="unit".
 */
function Dashboard({ unitId }) {
  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Overview</h1>
        <p className="dashboard-subtitle">Your focus today and operational signals</p>
      </div>
      <OverviewDashboard scope="unit" />
    </div>
  );
}

export default Dashboard;
